import './footer.scss';

document.addEventListener( 'DOMContentLoaded', function() {

    // Only target collapsable elements in the footer, not in archive filters
    const collapsable = document.querySelectorAll( 'footer .js-collapsable, .o-footer .js-collapsable' );

    collapsable.forEach( function( collapsable ) {

        collapsable.addEventListener( 'click', function() {

            collapsable.classList.toggle( '-active' );
            
        } );

    } );
} );